import Api, { ApiRefresh } from '@/api/config.ts';
import { apiUrls } from '@/api/api-urls.ts';
import {
  RefreshTokenRequest,
  RefreshTokeResponse,
  TelegramConnectRequest,
  TelegramConnectResponse
} from '@/api/login/types.ts';

const telegramConnect = async (payload: TelegramConnectRequest) => {
  const response = await Api.post<TelegramConnectResponse>(
    apiUrls.login.telegramConnect,
    payload
  );

  return response.data;
};

const refreshToken = async (payload: RefreshTokenRequest) => {
  const response = await ApiRefresh.post<RefreshTokeResponse>(
    apiUrls.login.refreshToken,
    payload
  );

  return response.data;
};

export default { telegramConnect, refreshToken };
